import "./menu-item-card.css";

import { IDataItem } from "../../../models/data.interface";
import { Util } from "../../../utils/util";
import { LocalizationService } from "../../../services/localization-service";

export class MenuItemCard {
    private readonly _localizationService: LocalizationService;
    private readonly _item: IDataItem;
    private readonly _card: HTMLElement;
    private readonly _element: HTMLElement;

    constructor(
        localizationService: LocalizationService,
        item: IDataItem,
        func?: Function,
        rewardData?: { pointsText: string; sizeText: string; locked: boolean },
        asHeading: boolean = false,
    ) {
        this._localizationService = localizationService;
        this._item = item;
        this._card = this._createElement(rewardData);
        this._element = asHeading ? this._wrapInHeading(this._card) : this._card;
        this._addClickHandler(func);
    }

    private _createElement(
        rewardData?: { pointsText: string; sizeText: string; locked: boolean },
    ): HTMLElement {
        const name = this._localizationService.GetName(this._item.Names);
        const description = this._localizationService.GetDescription(this._item.Descriptions);

        let pills = "";
        if (rewardData) {
            pills = this._createPillsForItem(rewardData.pointsText, rewardData.sizeText);
        }

        const html = `
            <div id="div_menu_items_item_${this._item.ItemId}" 
                name="div_menu_items_item"
                class="menu-item-card-small ${rewardData?.locked ? "card-locked" : ""}"
                data-id="${this._item.ItemId}"
                role="button"
                tabindex="0"
                aria-label="${name}, ${rewardData ? rewardData.pointsText + ", " : ""}${rewardData ? rewardData.sizeText + ", " : ""}${rewardData?.locked ? "Locked," : ""}">
                <div class="menu-item-card-small__image-container">
                    ${this._item.ImageURL && this._item.ImageURL.trim() != "" ? `<img class="menu-item-card-small__image" src="${this._item.ImageURL}" alt="${name}">` : ""}
                </div>
                <div class="menu-item-card-small__label-container">
                    <span class="menu-item-card-small__label" ltagj="${Util.toLtagj(this._item.Names)}">${name}</span>
                    <span class="menu-item-card-small__label-desc" ltagj="${Util.toLtagj(this._item.Descriptions)}">${description}</span>
                </div>
                ${pills}
            </div>`;

        return Util.createHtmlElementFromTemplate(html);
    }

    // An <h3> inside role="button" is flattened by screen readers, so the heading wraps the card instead.
    private _wrapInHeading(card: HTMLElement): HTMLElement {
        const heading = document.createElement("h3");
        heading.classList.add("menu-item-card-small__heading");
        heading.appendChild(card);
        return heading;
    }

    public get element(): HTMLElement {
        return this._element;
    }

    private _addClickHandler(func?: Function): void {
        if (!func) return;

        Util.setElement("onclick", this._card, func);
    }

    private _createPillsForItem(pointsText: string, sizeText: string): string {
        return `<div class="menu-item-card-small__pills">
                    <div class="menu-item-card-small__pill menu-item-card-small__pill--points">
                        <span class="icon-lock"></span><span>${pointsText}</span>
                    </div>
                    <div class="menu-item-card-small__pill menu-item-card-small__pill--size">
                        <span>${sizeText}</span> 
                    </div>
                </div>`;
    }
}
